<template>
    <div class="profile-section text-center pt-2 pl-2">
        <h5 class="text-left" v-if="currentRoute != 'contact'">
            <label class="underline">
            <a href="javascript:void(0)" @click="$router.push({ path: '/contact'})" class="text-black">
                <NeedHelpIcon :iconClass="pt-5" />
            Need Help?</a></label>
        </h5>
        <div class="profile-section" v-if="currentRoute != 'contact'">
            <ul class="list-unstyled mb-0">
                <li><strong>Email:</strong> <a href="mailto:support@mywingio.com">support@mywingio.com</a></li>
                <li><strong>Phone:</strong> <a href="tel:+447349970810">+44 7349 970810</a></li>
                <li>
                    <strong>Parent APP- Guide:</strong>
                    <a href="https://www.mywingio.com/how-it-works" target="_blank" rel="noopener noreferrer">
                        https://www.mywingio.com/how-it-works
                    </a>
                </li>
                <li>
                    <strong>Kids APP - Guide:</strong>
                    <a href="https://www.mywingio.com/wingio-child-app" target="_blank" rel="noopener noreferrer">
                        https://www.mywingio.com/wingio-child-app
                    </a>
                </li>
            </ul>
        </div>
        <!--<div class="text-left">
            <a class="pr-3 text-black" href="https://docs.google.com/document/d/168sPHF68dsXINSZntdDL8K8N6sUPePFAxtSIYq8BumQ/edit" target="_blank">Beta Tester Briefing</a>
            <a class="pr-3 text-black" href="https://docs.google.com/document/d/1ZtmAJNTUS85_CFPl_1iA8bXnUk1kLJsFOcuSlDSiFsA/edit?tab=t.0#heading=h.tt920hpeu0e1" target="_blank">Media Competence for Children</a>
        </div>-->
    </div>
    <div class="bg-dark text-white px-5 pt-4 pb-6 text-sm text-center">
        <p>Wingio 2025. All rights reserved</p>
        <hr>
        <div class="footer-links">
            <a href="https://www.mywingio.com/privacy" target="_blank">Privacy Policy</a>
            <a href="https://www.mywingio.com/terms-conditions" target="_blank">Terms & Conditions</a>
            <a href="https://www.mywingio.com/returns" target="_blank">Shipping & Returns</a>
            <a href="https://www.mywingio.com/warranty" target="_blank">Warranty</a>
        </div>
    </div>



</template>

<script>
import NeedHelpIcon from '@/components/icons/NeedHelpIcon.vue'

export default {
  name: 'KidFooter',
  components: {
    NeedHelpIcon
  },
  props: {
    profileDetail: Object
  },
  data() {
    return {
        currentRoute: this.$route.name
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.footer {
  background-color: #2c2f33; /* dark background */
  color: white;
  padding: 16px;
  text-align: center;
  font-size: 14px;
}

.footer hr {
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin: 12px auto;
  width: 80%;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-links a {
  color: #ffffff;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

/* Make links wrap horizontally on larger screens */
@media (min-width: 640px) {
  .footer-links {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
  }
}

</style>